import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'ttag';

import { Text } from '@components';

import { sectionHeadingClassName } from '../theme';
import PrizeCountdown from './PrizeCountdown';
import prizePropType from './prizePropType';

/**
 * The prizes section's heading beside its description, the countdown and the
 * competition terms. The two sit side by side from `lg`, top aligned, and stack below
 * that.
 */
export default function PrizesHeader({
  prizes,
  termsLink,
  onCountdownElapsed
}) {
  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] lg:items-start lg:gap-16">
      {/* Balanced, so the heading breaks between its two sentences rather than leaving
          the last word alone on a line. */}
      <h2 className={`${sectionHeadingClassName} [text-wrap:balance]`}>
        {t`New prize. Every day.`}
      </h2>
      <div className="grid max-w-[52ch] justify-items-start gap-5">
        <Text className="text-lg font-semibold leading-relaxed text-black md:text-xl">
          {t`Come back every day during Dream Week to discover a new prize and enter for your chance to win. You never know what's waiting behind the next door.`}
        </Text>
        <PrizeCountdown prizes={prizes} onElapsed={onCountdownElapsed} />
        <a
          href={termsLink}
          target="_blank"
          rel="noreferrer"
          className="text-black underline"
        >{t`Read Unisport's Competition Terms`}</a>
      </div>
    </div>
  );
}

PrizesHeader.propTypes = {
  prizes: PropTypes.arrayOf(prizePropType).isRequired,
  termsLink: PropTypes.string,
  onCountdownElapsed: PropTypes.func.isRequired
};

PrizesHeader.defaultProps = {
  termsLink: undefined
};
